import React from 'react';

const MinusSVG = ({ highlight, width, height, square, color }) => {
  if (square) {
    return (
      <svg width={width ?? "10"} height={height ?? "10"} viewBox="0 0 10 10" fill={color ?? window?.settings?.primary_color ?? '#1DBD6B'} xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.665 0H7.33C9.03 0 10 0.96 10 2.665V7.335C10 9.03 9.035 10 7.335 10H2.665C0.96 10 0 9.03 0 7.335V2.665C0 0.96 0.96 0 2.665 0ZM3 4.5C2.72386 4.5 2.5 4.72386 2.5 5C2.5 5.27614 2.72386 5.5 3 5.5H7C7.27614 5.5 7.5 5.27614 7.5 5C7.5 4.72386 7.27614 4.5 7 4.5H3Z" />
      </svg>
    )
  }
  return (
    <svg width="14" height="14" viewBox="0 0 20 20"
      fill={
        highlight
          ? "#04333"
          : "rgb(158, 172, 176)"
      }
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM14 11H6C5.4 11 5 10.6 5 10C5 9.4 5.4 9 6 9H14C14.6 9 15 9.4 15 10C15 10.6 14.6 11 14 11Z"></path>
    </svg>
  );
}

export default MinusSVG;